export const privateFormatDate = (date: string) => {
  const parts = date.split('-');
  const day = parseInt(parts[1]);
  const month = parseInt(parts[0]);
  const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];
  const monthName = months[month - 1];
  return `${day} ${monthName}`;
};
